function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#fff",
    width: "64px",
    height: "64px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "player-pain") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 25.866 18.166 C 27.229 16.773 27.579 14.874 26.649 13.923 C 25.719 12.972 23.86 13.33 22.497 14.723 C 22.231 14.994 22.006 15.284 21.819 15.582 C 17.145 12.706 5.373 19.47 12.896 25.25 L 6.948 25.25 L 5.63 27.683 L 18.451 27.683 L 14.04 22.422 C 15.249 21.062 17.402 20.195 18.875 20.126 C 19.563 22.424 20.682 25.908 22.451 27.682 L 25.486 27.682 C 23.338 25.31 21.668 22.122 21.4 18.517 C 21.48 18.682 21.584 18.833 21.714 18.966 C 22.644 19.918 24.503 19.559 25.866 18.166 Z M 10.054 20.431 C 10.809 15.912 17.545 13.477 21.535 14.93 L 24.1 8.405 L 20.007 12.612 L 20.965 4.37 L 18.878 9.258 L 18.186 7.29 L 16.556 11.544 L 12.534 3.675 L 13.225 10.997 L 6.732 5.573 L 10.352 12.7 L 6.478 11.198 L 8.187 14.364 L 4.095 14.258 L 9.331 17.731 L 4.14 19.26 L 10.054 20.429 L 10.054 20.431 Z",
    style: {}
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPain);
export default __webpack_public_path__ + "static/media/pain.f227f486d106ae81afdf7b18639681d8.svg";
export { ForwardRef as ReactComponent };